export const translation_11_2_A = {
  en: {},
  ko: {
    v1: {
      typography_0: `첫 번째 훈련법`,
      typography_1: `지난 시간에 마음을 인지하는 두 가지 훈련 방법이 있다고 배웠습니다. 기록을 통해 경험을 분리하는 연습과, 명상으로 주의력을 통제하는 훈련이었죠. 오늘은 그중 첫 번째 연습을 본격적으로 시작해 보겠습니다.`,
      typography_2: `이번 시간에 가장 먼저 배울 핵심 개념은 심리학에서 매우 중요하게 다루는 '경험 분리'입니다. 마음의 작용을 이해하기 위한 아주 기초적인 작업입니다. 스포츠나 악기를 처음 배울 때 기본기가 중요한 것처럼, 이 기본기만 확실히 익혀두어도 마음과 거리 두는 능력이 몰라보게 탄탄해질 것입니다.`,

      typography_3: `복잡한 경험 꾸러미`,
      typography_4: `마음속에 떠오르는 부정적인 생각과 거리를 둔 채 가만히 바라보기란 말처럼 쉽지 않습니다. 현실에서 마주하는 내면의 경험이 단순히 '생각'이라는 단일한 덩어리로만 이루어져 있지 않기 때문입니다.`,
      typography_5: `사실 마음속에서는 생각과 감정, 신체 반응, 그리고 행동과 충동이 복잡하게 뒤섞여 하나의 거대한 '꾸러미'처럼 한꺼번에 쏟아집니다.`,
      typography_6: `예를 들어 직장에서 무언가 실수를 한 상황을 떠올려 볼까요? "이번 프로젝트는 나 때문에 다 망했어"라는 생각과 동시에 죄책감이나 불안 같은 강렬한 감정이 파도처럼 밀려옵니다. 가슴이 답답해지거나 머리가 아픈 증상이 나타나기도 하고, 당장이라도 다 포기하고 도망치고 싶다는 충동까지 일어납니다. 이 모든 것이 하나의 꾸러미로 묶여서 다가오는 것이죠.`,
      typography_7: `다음 중 내면에서 뭉쳐지는 '경험 꾸러미'의 구성 요소가 아닌 것은 무엇일까요?`,
      typography_quiz_incorrect: `활동지를 천천히 살펴본 뒤 다시 답해보세요.`,
      typography_8: `정답은 D입니다. 실수를 저지른 '상황'은 내면의 반응을 촉발하는 외부 사건일 뿐, 경험 꾸러미에 속하지 않습니다. 경험 꾸러미는 특정 상황을 마주했을 때 마음속에서 덩어리져 일어나는 생각, 감정/신체 반응, 행동으로 구성됩니다.`,

      typography_9: `끝없는 악순환`,
      typography_10: `경험 꾸러미 속의 생각, 감정과 신체 반응, 행동과 충동은 멈춰 있지 않고 서로 끊임없이 영향을 주고받습니다. 부정적인 생각이 불안을 증폭시키고, 그 불안은 호흡을 가쁘게 만들어 더 극단적인 생각을 불러오기도 합니다. 마치 엉켜버린 털실 타래처럼 단단하게 뭉쳐서 끝없는 악순환을 만들어냅니다.`,
      typography_11: `이렇게 얽힌 꾸러미를 그대로 둔 채 생각과 거리를 두기란 거의 불가능합니다. 마음속에 정확히 어떤 생각이 스쳐 지나갔는지 파악하기 어려울 뿐만 아니라, 막연한 감정의 크기가 너무 압도적으로 느껴지기 때문입니다. 따라서 이 거대한 덩어리를 각각의 개별 요소로 가닥가닥 쪼개어 바라보는 연습이 필요합니다.`,
      typography_12: `위의 직장에서 무언가 실수를 한 상황 예시에서 '경험 꾸러미'를 분리한 모습은 다음과 같습니다.`,
      typography_bundle_thought: `이번 프로젝트는 나 때문에 다 망했어`,
      typography_bundle_emotion: `죄책감, 불안`,
      typography_bundle_body: `가슴이 답답함, 머리가 아픔`,
      typography_bundle_action: `포기하고 도망치고 싶었음`,

      typography_13: `실전 연습`,
      typography_14: `이처럼 얽혀 있는 마음의 덩어리를 개별 요소로 해체하는 과정을 '경험 분리'라고 부릅니다. 방법은 간단하지만 효과는 매우 강력합니다. 압도적인 감정에 휩쓸리지 않고 마음을 객관적으로 바라볼 수 있게 돕기 때문입니다.`,
      typography_15: `앞으로 벅차고 강렬한 감정을 마주하더라도, 일기장에 감정을 쏟아내듯 무작정 적어 내려가는 것은 피하는 게 좋습니다. 그 대신, 객관적인 '상황', 머릿속을 스쳐 간 '생각', 느껴진 '감정과 신체 반응', 그리고 '충동이나 실제 행동'을 명확히 나누어 기록해 보세요.`,
      typography_16: `이렇게 항목을 구분해 적는 것만으로도 혼란스러웠던 경험 꾸러미의 힘이 약해지고 마음에 여유가 생기는 것을 느낄 수 있습니다. 자, 그럼 다음 활동에서 이 '경험 분리'를 구체적으로 어떻게 실천할 수 있는지 함께 알아보겠습니다.`,
    },
  },
};
